import { render, staticRenderFns } from "./SignatureSettings.vue?vue&type=template&id=4ebd787f&scoped=true"
import script from "./SignatureSettings.vue?vue&type=script&lang=js"
export * from "./SignatureSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd787f",
  null
  
)

export default component.exports